angular.module('elidb').filter('textmatch', function() {
    return function(list,exp,bool) {
    	if(!list) return list;
       	var results = [];

       	for(var i  = 0, count = list.length; i < count; i++){
       		var item = list[i];

          //angular.trace(item,item.label,exp,bool,item.label.match(exp),"------");

       		if(bool && item.label.match(exp)) results.push(item);
       		else if(!bool && !item.label.match(exp)) results.push(item);
       	}

       // angular.trace(results);

       	return results;
    	
    };
});